@if (SuppliedQueryData) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="modal-header">
          <h3>Assignable Sites</h3>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="close()"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col" style="min-height: 400px">
              <app-sites-grid
                [gridName]="'AssignSitesToUser'"
                [suppliedQueryData]="SuppliedQueryData"
                [rowSelectionType]="'multiple'"
                [selectedRowsPrimaryKeys]="selectedRowsPrimaryKeys"
                (rowSelectionChanged)="rowSelectionChanged($event)"
                (selectionChanged)="siteSelectionChanged($event)"
              ></app-sites-grid>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row w-100 justify-content-end">
            <div class="col-2">
              <button class="btn btn-danger" (click)="close()">Close</button>
            </div>
            <div class="col-2">
              <button class="btn btn-primary" (click)="save()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
